<template>
    <div class="a-modal">
        <div class="popup__header popup__header--border">
            <span class="title title--sm popup__title">{{ title }}</span>
        </div>
        <div class="popup__content">
            <form class="a-modal__add-form form" @submit.prevent="getArticles(1)">
                <div class="form__item a-modal__separator">
                    <label class="form__item a-modal__big">
                        <span class="form__label">{{ $lang('AddLang.label.name') }}</span>

                        <el-popover v-model="errors.name.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.name.message">
                            <el-input slot="reference" :class="{ 'add__error': errors.name.isError}"
                                      @focus="clearErrors"
                                      :placeholder="$lang('AddLang.label.name.placeholder')" class="input input--big"
                                      :maxlength="50"
                                      v-model="form.name"></el-input>
                        </el-popover>
                    </label>

                    <label class="form__item a-modal__big">
                        <span class="form__label">Latinica</span>

                        <el-popover v-model="errors.latin.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.latin.message">
                            <el-input slot="reference" :class="{ 'add__error': errors.latin.isError}"
                                      @focus="clearErrors"
                                      placeholder="Russkij"
                                      class="input input--big"
                                      :maxlength="50"
                                      v-model="form.latin"></el-input>
                        </el-popover>
                    </label>

                    <label class="form__item a-modal__big">
                        <span class="form__label">{{ $lang('AddLang.label.url') }}</span>

                        <el-popover v-model="errors.url.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.url.message">
                            <el-input slot="reference"
                                      :class="{ 'add__error': errors.url.isError}"
                                      @focus="clearErrors"
                                      placeholder="ru"
                                      class="input input--big"
                                      :maxlength="2"
                                      v-model="form.url"></el-input>
                        </el-popover>
                    </label>

                    <label class="form__item a-modal__big">
                        <span class="form__label">{{ $lang('AddLang.label.currency') }}</span>

                        <el-popover v-model="errors.currency.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.currency.message">
                            <el-select slot="reference"
                                       :class="{ 'add__error': errors.currency.isError}"
                                       v-model="form.currency"
                                       :loading-text="$lang('el-select.loading')"
                                       :noDataText="$lang('el-select.noDataText')"
                                       :noMatchText="$lang('el-select.noMatchText')"
                                       :placeholder="$lang('AddLang.label.currency.placeholder')">
                                <el-option v-for="currency in currencies"
                                           :key="currency.abbr"
                                           :label="currency.name"
                                           :value="currency.abbr">
                                </el-option>
                            </el-select>
                        </el-popover>
                    </label>
                </div>

                <div class="form__item form__item--inline a-modal__separator">
                    <el-switch :inactive-text="$lang('AddLang.label.enable.text')"
                               class="switch switch--small switch--label"
                               v-model="form.enabled"/>
                </div>
            </form>
        </div>
        <div class="popup__footer">
            <button class="btn btn--middle btn--main-bg" @click="submit">{{ $lang('AddLang.label.save') }}</button>
        </div>
    </div>
</template>

<script>
import mixin from "../../../mixins/errors";
import ApiService from "../../../api/api";
import Vue from "vue";

export default {
    name: "AddLang",
    mixins: [mixin],
    props: {
        id: {
            type: Number,
            default: null
        },
        lang: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            form: {
                name: null,
                url: null,
                currency: null,
                enabled: false,
                latin: null
            },
            currencies: {
                0: {
                    abbr: 'rub',
                    name: Vue.prototype.$lang('AddLang.currencies.rub')
                },
                1: {
                    abbr: 'usd',
                    name: Vue.prototype.$lang('AddLang.currencies.usd')
                },
                2: {
                    abbr: 'eur',
                    name: Vue.prototype.$lang('AddLang.currencies.eur')
                },
            },
            errors: {
                name: {
                    isError: false,
                    message: ''
                },
                url: {
                    isError: false,
                    message: ''
                },
                currency: {
                    isError: false,
                    message: ''
                },
                latin: {
                    isError: false,
                    message: ''
                },
            },
        }
    },
    computed: {
        title() {
            return this.id ? this.$lang('AddLang.title.edit') : this.$lang('AddLang.title.add');
        }
    },
    watch: {
        'form.name': {
            handler(val, oldVal) {
                if (oldVal) {
                    const slug = require('slug');

                    this.form.latin = slug(val).charAt(0).toUpperCase() + slug(val).slice(1);
                }
            }
        },
    },
    mounted() {
        if (this.id) {
            if (this.lang) {
                this.getLangFromProps();
            } else {
                this.getLangFromDB();
            }
        }
    },
    methods: {
        getLangFromProps() {
            ['name', 'url', 'currency', 'enabled', 'latin'].forEach((key) => {
                this.form[key] = this.lang[key];
            });
        },
        getLangFromDB() {
            ApiService.get('/admin/langs/' + this.id).then((response) => {
                ['name', 'url', 'currency', 'enabled'].forEach((key) => {
                    this.form[key] = response.data[key];
                });
            });
        },
        submit() {
            this.$loading(this.$optionsLoading);

            this.id ? this.update() : this.store();
        },
        store() {
            ApiService.post('/admin/langs', this.form).then((response) => {
                window.location.href = '/cabinet/langs';
            }).catch((error) => {
                this.createErrors(error.response.data.errors);
            }).finally(() => {
                this.$loading({}).close();
            });
        },
        update() {
            this.form.id = this.id;

            ApiService.update('/admin/langs/' + this.id, this.form).then((response) => {
                window.location.href = '/cabinet/langs';
            }).catch((error) => {
                if (error.response.code === 500) {
                    this.$appNotify.error(error.response.data ?? this.$lang('AddLang.error'));
                } else {
                    this.createErrors(error.response.data.errors);
                }
            }).finally(() => {
                this.$loading({}).close();
            });
        }
    }
}
</script>
